import React from "react";
import "./contact.css";
import Separator from "../../../Common/Separator/index";
import SocialContact from "../../../Common/Social-Contact/index";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCloudArrowDown, faEnvelope} from "@fortawesome/free-solid-svg-icons";
import {faGithubSquare, faLinkedin} from "@fortawesome/free-brands-svg-icons";

function Contact() {
  return (
    <div className="contact">
      <Separator />
      <label className="section-title">Contact</label>
      <div className="contact-container">
        <div className="contact left">
          <p>
            Have cool ideas for a new project want to build a website?  Do you
            have a question? <br /> let's get in touch and build something together, or
            don't hesitate to contact me:
          </p>
          <div className="social-icon">
            <a href="https://www.linkedin.com/in/prince-kumar-3451a11ba">
          <FontAwesomeIcon icon={faLinkedin} size="2xl" style={{color: "#0a66c2",}} />
          </a>
          <a href="https://github.com/prince-111">
          <FontAwesomeIcon icon={faGithubSquare} size="2xl" style={{color: "#000000",}} />
          </a>
          <a href="mailto: princesd991@gmail.com">
          <FontAwesomeIcon icon={faEnvelope} size="2xl" style={{color: "#3e65cf",}} />
          </a>
          </div>
          <p>📍 Location: Gurgaon (Haryana) <br /> 📞 Calll on: +91 9693217690</p>

        </div>
        <div className="download">
          <a download href={require("../../../assets/resume.pdf")}>
          <FontAwesomeIcon icon={faCloudArrowDown} beat /> Download Resume
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
